// Load any Sane components that you might need.
// Don't load components that your are planning to extend in your
// custom components. Just the ones that you will directly use.
import {
  Toggle,
  Toggleable,
  SaneForm,
  // ScrollToTop,
} from 'sane-ui'

// Project specific / custom components
import App from './App'
import CustomScrollToTop from './CustomScrollToTop'
import HeroCopy from './HeroCopy'
import HeroMenu from './HeroMenu'
import LoadMore from './LoadMore'
import Logo from './Logo'
import Logos from './Logos'
import MediaComponent from './MediaComponent'
import MediaGallery from './MediaGallery'
import PageTransition from './PageTransition'
import Separator from './Separator'
import Testimonials from './Testimonials'
import VideoPlayer from './VideoPlayer'
import WorkCard from './WorkCard'
import SubscribeForm from './SubscribeForm'
// Animation parts
import Card from './animation/Card'
import Copy from './animation/Copy'
import Title from './animation/Title'

export {
  // Sane
  Toggle,
  Toggleable,
  SaneForm,

  // Project Specific
  App,
  CustomScrollToTop,
  HeroCopy,
  HeroMenu,
  LoadMore,
  Logo,
  Logos,
  MediaComponent,
  MediaGallery,
  PageTransition,
  Separator,
  Testimonials,
  VideoPlayer,
  WorkCard,
  SubscribeForm,

  // Animation parts
  Card,
  Copy,
  Title,
}



// WEBPACK FOOTER //
// ./scripts/components/index.js